<div class="p-4">
  <ziro-checkbox [fieldId]="'enabled'" [hidden]="true"></ziro-checkbox>
  <div class="row">
    <div class="col-6">
      <ziro-select [fieldId]="'requestDtmf'"></ziro-select>
      <ziro-radio [fieldId]="'offerPromptType'"></ziro-radio>
      <div [hidden]="entity.offerPromptType !== OfferPromptType.AUDIO_FILE">
        <ziro-file-upload [fieldId]="'offerAudioUpload'"></ziro-file-upload>
        @if (
          !isOfferAudioLoading() && entity.offerAudioUpload && acceptedFileTypes.includes(offerAudioFileExtension())
        ) {
          <audio
            [attr.data-automation]="'callback-offer-audio'"
            class="mt-2 w-100"
            controls
            [src]="offerAudioUploadURL()"
            [title]="offerAudioDownloadName()"
          ></audio>
        }
        <p class="mb-0 font-size-12">
          {{ 'tkey;teams_call_queue.callbacks.offer_prompt.audio_file.info' | translate }}
        </p>
      </div>
      <ziro-textarea
        [fieldId]="'offerTtsPrompt'"
        [hidden]="entity.offerPromptType !== OfferPromptType.TTS_MESSAGE"
      ></ziro-textarea>
    </div>
    <div class="col-6">
      <div class="strong">{{ 'tkey;teams_call_queue.callbacks.eligibility_conditions.label' | translate }}</div>
      <div class="font-sml-grey">
        {{ 'tkey;teams_call_queue.callbacks.eligibility_conditions.description' | translate }}
      </div>
      <ziro-text [fieldId]="'waitTimeBeforeOfferInSeconds'"></ziro-text>
      <ziro-text [fieldId]="'numberOfCallsInQueueBeforeOffer'"></ziro-text>
      <ziro-text [fieldId]="'callToAgentRatioThresholdBeforeOffer'"></ziro-text>
    </div>
  </div>
  <div class="row">
    <ziro-select class="col-6" [fieldId]="'notificationTargetGroup'"></ziro-select>
  </div>
</div>
